<template>
  <el-row class="a-body" id="login-page" :class="{ 'is-dark-theme': !isLightTheme }">
    <div class="solar-orbit solar-orbit-one"></div>
    <div class="solar-orbit solar-orbit-two"></div>
    <el-row class="a-body1">
      <el-row class="a-body2" :style="{ '--login-hero-image': 'url(' + loginHeroImage + ')' }">
        <div class="visual-shade"></div>
        <div v-if="isLightTheme" class="sun-core"></div>
        <div class="energy-line energy-line-one"></div>
        <div class="energy-line energy-line-two"></div>
        <div class="energy-line energy-line-three"></div>
        <div class="particle-field">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="brand-panel">
          <div class="brand-kicker">SOLAR ENERGY PLATFORM</div>
          <div class="brand-title">智能叠光控制系统</div>
          <div class="brand-subtitle">光伏能源 · 数字化监测 · 清洁能源管理</div>
        </div>
      </el-row>
      <el-row class="a-body3">
        <el-row class="a-body4">
          <div class="mobile-brand" aria-hidden="true">
            <div class="mobile-brand-mark">
              <span class="mobile-brand-sun"></span>
              <span class="mobile-brand-ray mobile-brand-ray-one"></span>
              <span class="mobile-brand-ray mobile-brand-ray-two"></span>
            </div>
            <div class="mobile-brand-title">智能叠光控制系统</div>
            <div class="mobile-brand-subtitle">光伏能源数字化管理平台</div>
          </div>
          <el-row class="a-body5">
            <el-row class="a-body6">
              登录
            </el-row>
            <el-row class="a-body7">
              <el-input
                label="账号"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
                v-model="subForm.userName"
                autocomplete="username"
                autocapitalize="off"
                spellcheck="false"
                @keyup.enter.native="subitForm"
              />
            </el-row>
            <el-row class="a-body7">
              <el-input
                label="密码"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                v-model="subForm.password"
                :type="passwordVisible ? 'text' : 'password'"
                autocomplete="current-password"
                @keyup.enter.native="subitForm"
              >
                <span
                  slot="suffix"
                  class="password-toggle"
                  role="button"
                  tabindex="0"
                  :aria-label="passwordVisible ? '隐藏密码' : '显示密码'"
                  @click="passwordVisible = !passwordVisible"
                  @keydown.enter.prevent="passwordVisible = !passwordVisible"
                  @keydown.space.prevent="passwordVisible = !passwordVisible"
                >
                  <img
                    class="password-toggle-icon"
                    :src="passwordToggleIcon"
                    alt=""
                  />
                </span>
              </el-input>
            </el-row>
            <el-row class="a-body8">
              <el-button type="primary" plain :loading="loginLoading" :disabled="loginLoading" @click="subitForm">登录</el-button>
            </el-row>
          </el-row>
        </el-row>
      </el-row>
    </el-row>
    <a
      class="beian-link"
      href="https://beian.miit.gov.cn"
      target="_blank"
      rel="noopener noreferrer"
    >粤ICP备20064069号</a>
  </el-row>
</template>

<script>
	import axios from 'axios'
	import { themeState } from '../../utils/theme';
	export default {
	    data() {
		  return {
			  subForm:{userName:'',password:'',loginCity:''},
			  loginLoading:false,
			  passwordVisible:false
		  }
		},
		computed: {
			isLightTheme() {
				return themeState.current === 'light';
			},
			loginHeroImage() {
				return this.isLightTheme
					? require('../../../static/login-solar-hero.jpg')
					: require('../../../static/login-solar-hero-night.jpg');
			},
			passwordToggleIcon() {
				return this.passwordVisible ? require('../../../static/preview.svg') : require('../../../static/preview-close.svg');
			}
		},
		mounted() {
			document.title='登录-智能叠光控制系统';
			document.body.classList.add('login-page-body');
			this.fetchCity();
			let subForm = localStorage.getItem("a-xny-userAndPass");
			if(subForm != null){
				// this.subForm = JSON.parse(subForm);
			}
		},
        destroyed() {
            document.body.classList.remove('login-page-body');
        },
		methods:{
			
			 async fetchCity() {
			   try {
			 	const response = await axios.get('http://ip-api.com/json?lang=zh-CN');
				this.subForm.loginCity = response.data.city;
				this.subForm.loginIp = response.data.query;
			   } catch (error) {
			   }
			 },
			/**
			 * 登录
			 */
			subitForm(){
				if(this.loginLoading) return;
				if(!this.subForm.userName){
					this.notifyError("请输入账户");
					return;
				}
				if(!this.subForm.password){
					this.notifyError("请输入密码");
					return;
				}
				this.loginLoading = true;
				this.$request.post('/api/user/login',this.subForm).then(response => {
					//登录成功
					if(this.isLoginSuccess(response.data)){
						localStorage.setItem("a-xny-userAndPass",JSON.stringify(this.subForm));
						localStorage.setItem("a-xny-token",response.data.data.token);
						localStorage.setItem("a-xny-userName",response.data.data.userName);
						localStorage.setItem("a-xny-level",response.data.data.userLevel);
						localStorage.setItem("a-xny-can-edit",response.data.data.canEdit == 2 ? 2 : 1);
						this.$router.push({
							name:'homeVue'
						});
					}else{
						this.notifyError(response.data.message || "登录失败，请检查账号或密码");
					}
				}).catch(error => {
					const errorResponse = error && error.response;
					const responseMessage = errorResponse && errorResponse.data && errorResponse.data.message;
					this.notifyError(errorResponse
						? (responseMessage || "登录失败，请稍后重试！")
						: "网络异常，登录失败！");
				}).finally(() => {
					this.loginLoading = false;
				})
			},
			isLoginSuccess(data) {
				if (!data) return false;
				if (data.result !== undefined) return data.result === true || data.result === 1 || data.result === '1';
				if (data.success !== undefined) return data.success === true || data.success === 1 || data.success === '1';
				if (data.code !== undefined) return data.code === 0 || data.code === 200 || data.code === '0' || data.code === '200';
				return !!(data.data && data.data.token);
			},
			notifyError(message) {
				if (this.$message) {
					this.$message.error(message);
					return;
				}
				if (this.$Message) this.$Message.error(message);
			}
		}
	}
</script>

<style scoped>
	.a-body {
		position: fixed !important;
		inset: 0 !important;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		width: auto !important;
		height: auto !important;
		margin: 0 !important;
		padding: 32px !important;
		overflow: hidden !important;
		background:
			radial-gradient(circle at 18% 16%, rgba(255, 185, 72, 0.24), transparent 27%),
			radial-gradient(circle at 86% 10%, rgba(var(--solar-primary-rgb, 0, 204, 255), 0.18), transparent 28%),
			linear-gradient(135deg, var(--solar-page, #001A33) 0%, var(--solar-surface, #002B4D) 46%, var(--solar-raised, #003C66) 100%) !important;
		font-family: "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
	}

	.a-body::before {
		content: "";
		position: absolute;
		inset: 0;
		background:
			linear-gradient(90deg, rgba(var(--solar-primary-rgb, 0, 204, 255), 0.07) 1px, transparent 1px),
			linear-gradient(0deg, rgba(var(--solar-primary-rgb, 0, 153, 255), 0.05) 1px, transparent 1px);
		background-size: 72px 72px;
		mask-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.72), transparent 78%);
		pointer-events: none;
	}

	.beian-link {
		position: absolute;
		left: 50%;
		bottom: 16px;
		z-index: 2;
		transform: translateX(-50%);
		color: rgba(var(--solar-text-strong-rgb, 215, 246, 255), 0.72);
		font-size: 13px;
		line-height: 20px;
		text-decoration: none;
		transition: color 0.2s ease;
	}

	.beian-link:hover {
		color: var(--solar-text-strong, #ffffff);
	}

	.solar-orbit {
		position: absolute;
		border: 1px solid rgba(var(--solar-border-strong-rgb, 0, 204, 255), 0.16);
		border-radius: 50%;
		box-shadow: inset 0 0 24px rgba(var(--solar-primary-rgb, 0, 153, 255), 0.08);
		pointer-events: none;
	}

	.solar-orbit-one {
		width: 480px;
		height: 480px;
		left: -160px;
		top: -140px;
	}

	.solar-orbit-two {
		width: 620px;
		height: 620px;
		right: -240px;
		bottom: -260px;
		border-color: rgba(255, 190, 92, 0.16);
	}

	.a-body1 {
		position: relative;
		z-index: 1;
		display: flex;
		width: min(1120px, calc(100vw - 64px));
		height: min(640px, calc(100vh - 64px));
		min-height: 520px;
		margin: 0;
		overflow: hidden !important;
		border: 1px solid rgba(135, 206, 250, 0.28);
		border-radius: 20px;
		background: rgba(var(--solar-surface-rgb, 0, 43, 77), 0.32) !important;
		box-shadow: 0 30px 90px rgba(0, 10, 24, 0.46), inset 0 1px 0 rgba(255, 255, 255, 0.16);
		backdrop-filter: blur(18px);
	}

	.a-body2 {
		position: relative;
		flex: 1 1 58%;
		width: 58%;
		min-width: 0;
		height: 100%;
		overflow: hidden !important;
		background: var(--login-hero-image) center center / cover no-repeat !important;
	}

	.is-dark-theme .a-body2 {
		background:
			linear-gradient(90deg, rgba(0, 12, 28, 0.18), rgba(0, 12, 28, 0.02)),
			var(--login-hero-image) center center / cover no-repeat !important;
	}

	.is-dark-theme .visual-shade {
		background: linear-gradient(90deg, rgba(0, 12, 28, 0.32), rgba(0, 20, 43, 0.06) 52%, rgba(0, 12, 28, 0.22));
	}

	.is-dark-theme .energy-line {
		background: linear-gradient(90deg, transparent, rgba(0, 204, 255, 0.72), rgba(168, 214, 255, 0.7), transparent);
	}

	.visual-shade {
		position: absolute;
		inset: 0;
		/* 日景保留照片原色，仅在底部文字区域轻微压暗。 */
		background: linear-gradient(0deg, rgba(21, 36, 30, 0.36), rgba(21, 36, 30, 0.08) 28%, transparent 52%);
	}

	.visual-shade::after {
		content: "";
		position: absolute;
		inset: 0;
		background: linear-gradient(120deg, transparent 0%, rgba(255, 255, 255, 0.18) 46%, transparent 58%);
		transform: translateX(-120%);
		animation: lightSweep 7s ease-in-out infinite;
	}

	.sun-core {
		position: absolute;
		top: 54px;
		right: 74px;
		width: 112px;
		height: 112px;
		border-radius: 50%;
		background: radial-gradient(circle, rgba(255, 245, 213, 0.95) 0%, rgba(255, 190, 82, 0.58) 34%, rgba(255, 190, 82, 0) 68%);
		filter: blur(1px);
		animation: sunPulse 4.8s ease-in-out infinite;
	}

	.energy-line {
		position: absolute;
		left: 48px;
		right: 36px;
		height: 2px;
		border-radius: 999px;
		background: linear-gradient(90deg, transparent, rgba(var(--solar-primary-rgb, 0, 204, 255), 0.86), rgba(255, 190, 82, 0.9), transparent);
		box-shadow: 0 0 16px rgba(var(--solar-primary-rgb, 0, 204, 255), 0.58);
		opacity: 0.72;
		animation: energyFlow 4.6s linear infinite;
	}

	.energy-line-one {top: 42%; transform: rotate(-13deg);}
	.energy-line-two {top: 56%; transform: rotate(10deg); animation-delay: -1.2s;}
	.energy-line-three {top: 69%; transform: rotate(-6deg); animation-delay: -2.4s;}

	.particle-field span {
		position: absolute;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #00FF9A;
		box-shadow: 0 0 14px rgba(0, 255, 154, 0.86);
		animation: particleRise 6s ease-in-out infinite;
	}

	.particle-field span:nth-child(1) {left: 18%; top: 72%; animation-delay: -0.5s;}
	.particle-field span:nth-child(2) {left: 34%; top: 64%; animation-delay: -2s;}
	.particle-field span:nth-child(3) {left: 52%; top: 76%; animation-delay: -3.2s;}
	.particle-field span:nth-child(4) {left: 66%; top: 58%; animation-delay: -1.4s;}
	.particle-field span:nth-child(5) {left: 78%; top: 68%; animation-delay: -4.1s;}
	.particle-field span:nth-child(6) {left: 88%; top: 50%; animation-delay: -2.8s;}

	.brand-panel {
		position: absolute;
		left: 46px;
		bottom: 46px;
		width: calc(100% - 92px);
		color: var(--solar-text-strong, #ffffff);
	}

	.brand-kicker {
		margin-bottom: 12px;
		color: var(--solar-text, #87CEFA);
		font-size: 12px;
		font-weight: 700;
		letter-spacing: 2px;
	}

	.brand-title {
		font-size: 34px;
		font-weight: 700;
		line-height: 1.2;
		letter-spacing: 1px;
		text-shadow: 0 0 22px rgba(var(--solar-primary-rgb, 0, 153, 255), 0.48);
	}

	.brand-subtitle {
		margin-top: 14px;
		color: rgba(var(--solar-text-strong-rgb, 215, 246, 255), 0.86);
		font-size: 14px;
		letter-spacing: 1px;
	}

	.mobile-brand {
		display: none;
	}

	.a-body3 {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 42%;
		width: 42%;
		min-width: 380px;
		height: 100%;
		overflow: hidden !important;
		background:
			linear-gradient(180deg, rgba(var(--solar-raised-rgb, 0, 60, 102), 0.78), rgba(var(--solar-page-rgb, 0, 26, 51), 0.9)),
			radial-gradient(circle at 50% 0%, rgba(var(--solar-primary-rgb, 0, 204, 255), 0.2), transparent 48%) !important;
		backdrop-filter: blur(24px);
	}

	.a-body3::before {
		content: "";
		position: absolute;
		inset: 0;
		background:
			linear-gradient(90deg, rgba(var(--solar-primary-rgb, 0, 204, 255), 0.24), transparent 1px) left top / 1px 100% no-repeat,
			linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(var(--solar-primary-rgb, 0, 153, 255), 0.04));
		pointer-events: none;
	}

	.a-body4 {
		position: relative;
		z-index: 1;
		width: min(330px, calc(100% - 58px));
		margin: 0 auto;
	}

	.a-body5 {
		position: relative;
		min-height: 332px;
		padding: 44px 34px 36px;
		border: 1px solid rgba(var(--solar-border-strong-rgb, 0, 153, 255), 0.38);
		border-radius: 18px;
		background:
			linear-gradient(180deg, rgba(var(--solar-surface-rgb, 0, 43, 77), 0.72), rgba(var(--solar-page-rgb, 0, 26, 51), 0.62)),
			radial-gradient(circle at 50% 0%, rgba(var(--solar-primary-rgb, 0, 204, 255), 0.14), transparent 56%) !important;
		box-shadow: 0 24px 54px rgba(0, 10, 24, 0.34), inset 0 1px 0 rgba(176, 226, 255, 0.18);
		backdrop-filter: blur(22px);
	}

	.a-body6 {
		margin-bottom: 34px;
		color: var(--solar-text-strong, #ffffff);
		font-size: 26px;
		font-weight: 700;
		text-align: center;
		letter-spacing: 4px;
		text-shadow: 0 0 18px rgba(var(--solar-primary-rgb, 0, 153, 255), 0.42);
	}

	.a-body7 {
		margin-top: 18px;
	}

	.a-body8 {
		margin-top: 38px;
	}

	/deep/.a-body7 .el-input {
		border: none !important;
		box-shadow: none !important;
		background: transparent !important;
	}

	/deep/.el-input__wrapper {
		border: none !important;
		background: transparent !important;
		box-shadow: none !important;
		box-sizing: border-box !important;
	}

	/deep/.el-input__wrapper:hover,
	/deep/.el-input.is-focus .el-input__wrapper,
	/deep/.el-input__wrapper.is-focus {
		border: none !important;
		background: transparent !important;
		box-shadow: none !important;
	}

	/deep/.el-input__inner,
	/deep/.el-input__inner:hover,
	/deep/.el-input__inner:focus {
		outline: none !important;
	}

	/deep/.el-input__inner {
		height: 46px !important;
		line-height: 46px !important;
		padding-left: 42px !important;
		border: 1px solid rgba(var(--solar-border-strong-rgb, 0, 153, 255), 0.46) !important;
		border-radius: 14px !important;
		background: rgba(var(--solar-page-rgb, 0, 26, 51), 0.5) !important;
		box-shadow: inset 0 1px 0 rgba(176, 226, 255, 0.12), 0 10px 24px rgba(0, 10, 24, 0.14) !important;
		color: var(--solar-text-strong, #d7f6ff) !important;
		font-size: 14px !important;
		transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
	}

	/deep/.el-input__inner:hover,
	/deep/.el-input__inner:focus {
		border-color: var(--solar-border-strong, #00CCFF) !important;
		background: rgba(var(--solar-surface-rgb, 0, 43, 77), 0.72) !important;
		box-shadow: 0 0 0 4px rgba(var(--solar-primary-rgb, 0, 204, 255), 0.14), 0 12px 28px rgba(0, 10, 24, 0.22) !important;
	}

	/deep/.el-input__inner::placeholder {
		color: var(--solar-text, #87CEFA) !important;
	}

	/deep/.el-input__prefix {
		left: 14px !important;
		color: var(--solar-primary, #00CCFF) !important;
	}

	/deep/.el-input__icon {
		line-height: 46px !important;
	}

	/deep/.el-input__suffix {
		right: 12px !important;
	}

	/deep/.password-toggle {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 46px;
		margin-right: -12px;
		cursor: pointer;
		touch-action: manipulation;
	}

	/deep/.password-toggle-icon {
		width: 18px;
		height: 18px;
		display: block;
		opacity: 0.78;
		transition: opacity 0.2s ease, transform 0.2s ease;
	}

	/deep/.password-toggle:hover .password-toggle-icon,
	/deep/.password-toggle:focus .password-toggle-icon {
		opacity: 1;
		transform: scale(1.06);
	}

	.a-body7 /deep/.el-input__suffix + .el-input__inner,
	.a-body7 /deep/.el-input--suffix .el-input__inner {
		padding-right: 42px !important;
	}

	/deep/.el-button {
		width: 100% !important;
		height: 48px !important;
		border: none !important;
		border-radius: 14px !important;
		background: linear-gradient(135deg, var(--solar-primary, #0099FF) 0%, var(--solar-primary, #00CCFF) 52%, #FFC857 100%) !important;
		box-shadow: 0 16px 28px rgba(var(--solar-primary-rgb, 0, 153, 255), 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.35) !important;
		color: var(--solar-text-strong, #ffffff) !important;
		font-size: 16px !important;
		font-weight: 700 !important;
		letter-spacing: 4px;
		transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
	}

	/deep/.el-button:hover {
		transform: translateY(-1px);
		filter: saturate(1.08);
		box-shadow: 0 20px 34px rgba(var(--solar-primary-rgb, 0, 153, 255), 0.34), 0 0 22px rgba(255, 200, 87, 0.22) !important;
	}

	@keyframes lightSweep {
		0%, 52% {transform: translateX(-120%);}
		100% {transform: translateX(120%);}
	}

	@keyframes sunPulse {
		0%, 100% {transform: scale(0.94); opacity: 0.82;}
		50% {transform: scale(1.08); opacity: 1;}
	}

	@keyframes energyFlow {
		0% {background-position: -360px 0; opacity: 0.22;}
		45% {opacity: 0.9;}
		100% {background-position: 360px 0; opacity: 0.22;}
	}

	@keyframes particleRise {
		0%, 100% {transform: translate3d(0, 0, 0); opacity: 0.25;}
		50% {transform: translate3d(12px, -54px, 0); opacity: 1;}
	}

	@media (max-width: 860px) {
		.a-body {
			align-items: flex-start !important;
			justify-content: flex-start !important;
			flex-direction: column;
			padding: max(18px, env(safe-area-inset-top)) 18px max(10px, env(safe-area-inset-bottom)) !important;
			overflow-x: hidden !important;
			overflow-y: auto !important;
			-webkit-overflow-scrolling: touch;
		}

		.beian-link {
			position: static;
			flex: 0 0 auto;
			transform: none;
			margin: 10px auto 0;
			font-size: 12px;
		}

		.a-body1 {
			width: calc(100vw - 36px);
			height: auto;
			min-height: 0;
			flex: 0 0 auto;
			flex-direction: column;
		}

		.a-body2 {
			width: 100%;
			flex: 0 0 220px;
		}

		.brand-panel {
			left: 24px;
			bottom: 24px;
			width: calc(100% - 48px);
		}

		.brand-title {
			font-size: 24px;
		}

		.a-body3 {
			width: 100%;
			min-width: 0;
			flex: none;
			padding: 26px 0;
		}

		.a-body4 {
			width: min(350px, calc(100% - 36px));
		}
	}

	@media (max-width: 560px) {
		.a-body {
			padding-right: max(16px, env(safe-area-inset-right)) !important;
			padding-left: max(16px, env(safe-area-inset-left)) !important;
			background:
				radial-gradient(circle at 50% -8%, rgba(255, 185, 72, 0.28), transparent 30%),
				radial-gradient(circle at 96% 42%, rgba(var(--solar-primary-rgb, 0, 204, 255), 0.18), transparent 38%),
				linear-gradient(160deg, var(--solar-page, #001A33) 0%, var(--solar-surface, #002B4D) 58%, var(--solar-raised, #003C66) 100%) !important;
		}

		.a-body::before {
			background-size: 46px 46px;
		}

		.solar-orbit-one {
			width: 300px;
			height: 300px;
			left: -190px;
			top: -140px;
		}

		.solar-orbit-two {
			width: 360px;
			height: 360px;
			right: -250px;
			bottom: 0;
		}

		.a-body2 {
			display: none;
		}

		.a-body1 {
			width: 100%;
			border: none;
			border-radius: 0;
			background: transparent !important;
			box-shadow: none;
			backdrop-filter: none;
		}

		.a-body3 {
			min-height: calc(100dvh - 72px - env(safe-area-inset-top) - env(safe-area-inset-bottom));
			padding: clamp(28px, 7vh, 64px) 0 20px;
			background: transparent !important;
			backdrop-filter: none;
		}

		.a-body3::before {
			display: none;
		}

		.a-body4 {
			width: min(100%, 380px);
		}

		.mobile-brand {
			display: flex;
			align-items: center;
			flex-direction: column;
			margin-bottom: clamp(24px, 5vh, 38px);
			color: var(--solar-text-strong, #ffffff);
			text-align: center;
		}

		.mobile-brand-mark {
			position: relative;
			width: 58px;
			height: 58px;
			margin-bottom: 16px;
			border: 1px solid rgba(135, 206, 250, 0.36);
			border-radius: 18px;
			background: linear-gradient(145deg, rgba(var(--solar-primary-rgb, 0, 204, 255), 0.16), rgba(255, 200, 87, 0.12));
			box-shadow: 0 14px 34px rgba(0, 10, 24, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.18);
		}

		.mobile-brand-sun {
			position: absolute;
			top: 14px;
			left: 15px;
			width: 19px;
			height: 19px;
			border-radius: 50%;
			background: #ffc857;
			box-shadow: 0 0 20px rgba(255, 200, 87, 0.72);
		}

		.mobile-brand-ray {
			position: absolute;
			left: 13px;
			bottom: 14px;
			width: 32px;
			height: 2px;
			border-radius: 999px;
			background: linear-gradient(90deg, var(--solar-primary, #00ccff), #00ff9a);
			box-shadow: 0 0 10px rgba(var(--solar-primary-rgb, 0, 204, 255), 0.64);
		}

		.mobile-brand-ray-one {
			transform: rotate(-15deg);
		}

		.mobile-brand-ray-two {
			bottom: 9px;
			width: 25px;
			transform: rotate(8deg);
		}

		.mobile-brand-title {
			font-size: 24px;
			font-weight: 700;
			line-height: 1.3;
			letter-spacing: 1px;
			text-shadow: 0 0 22px rgba(var(--solar-primary-rgb, 0, 153, 255), 0.46);
		}

		.mobile-brand-subtitle {
			margin-top: 8px;
			color: rgba(var(--solar-text-strong-rgb, 215, 246, 255), 0.76);
			font-size: 13px;
			letter-spacing: 1px;
		}

		.a-body5 {
			min-height: 0;
			padding: 30px 24px 26px;
			border-color: rgba(var(--solar-border-strong-rgb, 0, 204, 255), 0.32);
			border-radius: 20px;
			background: linear-gradient(180deg, rgba(var(--solar-raised-rgb, 0, 52, 88), 0.86), rgba(var(--solar-page-rgb, 0, 26, 51), 0.78)) !important;
			box-shadow: 0 22px 54px rgba(0, 10, 24, 0.36), inset 0 1px 0 rgba(176, 226, 255, 0.16);
		}

		.a-body6 {
			margin-bottom: 26px;
			font-size: 22px;
		}

		.a-body7 {
			margin-top: 16px;
		}

		.a-body8 {
			margin-top: 28px;
		}

		/deep/.el-input__inner {
			height: 52px !important;
			line-height: 52px !important;
			font-size: 16px !important;
		}

		/deep/.el-input__icon {
			line-height: 52px !important;
		}

		/deep/.password-toggle {
			height: 52px;
		}

		/deep/.el-button {
			height: 52px !important;
			touch-action: manipulation;
		}

		.beian-link {
			min-height: 32px;
			padding: 6px 12px;
			line-height: 20px;
		}
	}

	@media (max-width: 360px) {
		.a-body {
			padding-right: max(10px, env(safe-area-inset-right)) !important;
			padding-left: max(10px, env(safe-area-inset-left)) !important;
		}

		.a-body3 {
			padding-top: 22px;
		}

		.mobile-brand {
			margin-bottom: 22px;
		}

		.mobile-brand-title {
			font-size: 21px;
		}

		.a-body5 {
			padding: 26px 18px 22px;
		}
	}

	@media (max-height: 560px) and (max-width: 860px) {
		.solar-orbit-two {
			bottom: 0;
		}

		.a-body2 {
			display: none;
		}

		.a-body3 {
			width: 100%;
			min-width: 0;
			padding: 18px 0;
		}

		.mobile-brand {
			display: none;
		}

		.a-body5 {
			min-height: 0;
			padding: 22px 30px 20px;
		}

		.a-body6 {
			margin-bottom: 20px;
			font-size: 23px;
		}

		.a-body7 {
			margin-top: 12px;
		}

		.a-body8 {
			margin-top: 22px;
		}

		/deep/.el-input__inner {
			height: 44px !important;
			line-height: 44px !important;
		}

		/deep/.el-input__icon,
		/deep/.password-toggle {
			height: 44px;
			line-height: 44px !important;
		}

		/deep/.el-button {
			height: 46px !important;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.visual-shade::after,
		.sun-core,
		.energy-line,
		.particle-field span {
			animation: none !important;
		}
	}
</style>

<style>
  body.login-page-body #app {
    transform: none !important;
    -webkit-transform: none !important;
    width: 100vw !important;
    height: 100vh !important;
    overflow: hidden !important;
  }

  body.login-page-body {
    overflow: hidden !important;
  }

  #login-page {
    position: fixed !important;
    inset: 0 !important;
    height: auto !important;
    width: auto !important;
    min-height: 100vh !important;
    min-width: 100vw !important;
    overflow: hidden !important;
    z-index: 9999 !important;
  }
  #login-page * {
    box-sizing: border-box;
  }

  #login-page .el-input__inner {
    color: var(--solar-text-strong, #d7f6ff) !important;
  }

  #login-page .a-body7 .el-input {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  #login-page .el-input__wrapper {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
  }

  #login-page .el-input__wrapper:hover,
  #login-page .el-input.is-focus .el-input__wrapper,
  #login-page .el-input__wrapper.is-focus {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  #login-page .el-input__inner,
  #login-page .el-input__inner:hover,
  #login-page .el-input__inner:focus {
    outline: none !important;
  }

  #login-page .el-input__inner {
    height: 46px !important;
    line-height: 46px !important;
    padding-left: 42px !important;
    border: 1px solid rgba(var(--solar-border-strong-rgb, 0, 153, 255), 0.46) !important;
    border-radius: 14px !important;
    background: rgba(var(--solar-page-rgb, 0, 26, 51), 0.5) !important;
    box-shadow: inset 0 1px 0 rgba(176, 226, 255, 0.12), 0 10px 24px rgba(0, 10, 24, 0.14) !important;
  }

  #login-page .el-input__inner:hover,
  #login-page .el-input__inner:focus {
    border-color: var(--solar-border-strong, #00CCFF) !important;
    background: rgba(var(--solar-surface-rgb, 0, 43, 77), 0.72) !important;
    box-shadow: 0 0 0 4px rgba(var(--solar-primary-rgb, 0, 204, 255), 0.14), 0 12px 28px rgba(0, 10, 24, 0.22) !important;
  }

  #login-page .el-button--primary {
    --el-button-text-color: var(--solar-text-strong, #fff) !important;
  }

  body.login-page-body .el-message {
    z-index: 10001 !important;
  }

  @media (max-width: 860px) {
    #login-page {
      height: 100dvh !important;
      min-height: 100vh !important;
      min-height: 100dvh !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
    }
  }
</style>
